export default __webpack_public_path__ + "static/media/Dhaka_banner.e425174b.jpg";